(function () {
    "use strict";

    angular
        .module("atheer.services")
        .factory("DeviceInfoService", DeviceInfoService);

    /* @ngInject */
    function DeviceInfoService($q, deviceDetector) {
        var service = {
            getDeviceInfo: getDeviceInfo,
            getDeviceInfoAsync: getDeviceInfoAsync,
            detectBrowser: detectBrowser,
            getOSVersionFromUA: getOSVersionFromUA,
        };

        return service;

        function getDeviceInfo() {
            var deviceInfo = {
                deviceType: getDeviceType(),
                deviceSubType: getDeviceSubType(),
                os: getOS(),
                osVersion: getOSVersion(),
                deviceModel: getDeviceModel(),
                browser: detectBrowser(),
                eventTime: Date.now(),
                eventTZ: getTimeZone(),
            };

            return deviceInfo;
        }

        function getDeviceInfoAsync() {
            var deferred = $q.defer();

            // Get basic device info immediately
            var deviceInfo = getDeviceInfo();

            // Try to get high entropy values asynchronously
            tryGetHighEntropyValues()
                .then(function (platformVersion) {
                    if (platformVersion) {
                        deviceInfo.osVersion = platformVersion;
                    }
                    deferred.resolve(deviceInfo);
                })
                .catch(function (error) {
                    console.error(
                        "High entropy values not available, using fallback"
                    );
                    deferred.resolve(deviceInfo);
                });

            return deferred.promise;
        }

        function getDeviceType() {
            if (deviceDetector.isDesktop()) {
                return "DESKTOP";
            } else if (deviceDetector.isMobile()) {
                return "HANDHELD";
            } else if (deviceDetector.isTablet()) {
                return "HANDHELD";
            }
            return "OTHER";
        }

        function getDeviceSubType() {
            if (deviceDetector.isDesktop()) {
                return "DESKTOP";
            } else if (deviceDetector.isMobile()) {
                return "PHONE";
            } else if (deviceDetector.isTablet()) {
                return "TABLET";
            }
            return "OTHER";
        }

        function getOS() {
            return deviceDetector.os.toUpperCase();
        }

        function getOSVersion() {
            return getOSVersionFromUA().version.toUpperCase();
        }

        function getDeviceModel() {
            return "UNKNOWN DEVICE";
        }

        function getTimeZone() {
            return (
                (Intl &&
                    Intl.DateTimeFormat &&
                    Intl.DateTimeFormat().resolvedOptions &&
                    Intl.DateTimeFormat().resolvedOptions().timeZone) ||
                "GMT"
            );
        }

        function getOSVersionFromUA() {
            var ua = navigator.userAgent;
            var mac = ua.match(/Mac OS X (\d+)[_.](\d+)(?:[_.](\d+))?/);
            var ios = ua.match(
                /(?:iPhone|CPU|iPad).*OS (\d+)[_.](\d+)(?:[_.](\d+))?/
            );
            var android = ua.match(/Android (\d+)\.(\d+)(?:\.(\d+))?/);
            var windows = ua.match(/Windows NT (\d+)\.(\d+)(?:\.(\d+))?/);
            var linux = ua.match(/Linux/);

            var normalize = function (match) {
                var a = match[1] || "0";
                var b = match[2] || "0";
                var c = match[3] || "0";
                return a + "." + b + "." + c;
            };

            if (mac) return { os: "macOS", version: normalize(mac) };
            if (ios)
                return {
                    os: /iPad/.test(ua) ? "iPadOS" : "iOS",
                    version: normalize(ios),
                };
            if (android) return { os: "Android", version: normalize(android) };
            if (windows) return { os: "Windows", version: normalize(windows) };
            if (linux) return { os: "Linux", version: "" };

            return { os: "Unknown", version: "" };
        }

        function detectBrowser() {
            var browser = deviceDetector.browser
                .toUpperCase()
                .replace(/-/g, "_");
            var userAgent = navigator.userAgent.toUpperCase();
            // Check for Vivaldi first
            if (
                typeof window.vivaldi !== "undefined" ||
                /vivaldi/i.test(navigator.userAgent)
            ) {
                return "VIVALDI";
            }
            // Check for Edge
            else if (
                browser.includes("EDGE") || userAgent.includes("EDGE")
            ) {
                return "EDGE";
            }
            // Check for Brave
            else if (
                navigator.brave &&
                navigator.brave.isBrave &&
                navigator.brave.isBrave()
            ) {
                return "BRAVE";
            }
            // Check for Samsung Internet
            else if (
                ["Samsung", "SAMSUNG"].indexOf(browser) !== -1 ||
                userAgent.includes("SAMSUNG")
            ) {
                return "SAMSUNG_INTERNET";
            }
            // Check for other browsers
            else if (browser === "CHROME") {
                return "CHROME";
            } else if (browser === "FIREFOX") {
                return "FIREFOX";
            } else if (browser === "SAFARI") {
                return "SAFARI";
            } else if (browser === "OPERA") {
                return "OPERA";
            } else if (
                browser === "UC_BROWSER" ||
                userAgent.includes("UCBROWSER")
            ) {
                return "UC_BROWSER";
            }

            return "OTHER";
        }

        function tryGetHighEntropyValues() {
            var deferred = $q.defer();

            try {
                if (
                    navigator.userAgentData &&
                    navigator.userAgentData.getHighEntropyValues
                ) {
                    navigator.userAgentData
                        .getHighEntropyValues(["platform", "platformVersion"])
                        .then(function (userAgentData) {
                            if (
                                userAgentData &&
                                userAgentData.platformVersion
                            ) {
                                deferred.resolve(userAgentData.platformVersion);
                            } else {
                                deferred.reject(
                                    "No platform version available"
                                );
                            }
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                } else {
                    deferred.reject("High entropy values not supported");
                }
            } catch (error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
